import { Button } from "@mantine/core";
import { IconFileDescription } from "@tabler/icons-react";
import { usePage } from "@inertiajs/react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { DesignBriefModal } from "./DesignBriefModal";

/**
 * AD-222: "Check Design Brief" in the editor header — for an admin on a "Let Us
 * Design It" ad, the brief and the customer's feedback while designing.
 */
export const CheckDesignBriefButton = () => {

    const { t } = useTranslation();
    const { designRequestId } = usePage().props;
    const [opened, setOpened] = useState(false);

    if (!designRequestId) {
        return null;
    }

    return (
        <>
            <Button leftSection={<IconFileDescription size={18} />} variant="default" radius="md" onClick={() => setOpened(true)}>
                {t('designRequests.checkBrief')}
            </Button>
            <DesignBriefModal designRequestId={designRequestId} opened={opened} onClose={() => setOpened(false)} inEditor />
        </>
    );
};
